require('js/main/ga-tracking.js');
require('js/main/star.js');
require('js/main/navbar.js');
require('sass/main-2015/press.scss');

var $mediaResources = document.querySelectorAll('.pressKit-link');
var $articles = document.querySelectorAll('.articles a');

for (var i = 0; i < $mediaResources.length; i++) {
  $mediaResources[i].onclick = function () {
    ga('send', 'event', 'link', 'click', 'downloaded ' + this.download);
  }
}
for (var i = 0; i < $articles.length; i++) {
  $articles[i].onclick = (function (hash) {
    return function () {
      ga('send', 'event', 'link', 'click', 'view-article');
    }
  })($articles[i].hash);
}



/*****************
 ** WEBPACK FOOTER
 ** ./js/main/press.js
 ** module id = 478
 ** module chunks = 5
 **/